import { KeywordGroupsField } from '@app/components/Modals/BotDetailsModal/components/KeywordGroupsField';
import { SocialChannelFields } from '@app/components/Modals/BotDetailsModal/components/SocialChannelFields';
import { INCOMING_MESSAGE_KEYWORD_GROUPS_LIMITS } from '@app/components/Modals/BotDetailsModal/constants/keywordGroups';

import type { FormInstance } from 'antd';
import type { BaseOptionType } from 'antd/es/select';
import type { FC } from 'react';

interface IncomingMessageTriggerFieldsProps {
  form: FormInstance;
  socialIntegrationTypeValue: number | string | null | undefined;
  filteredIntegrations: BaseOptionType[];
  handleChannelOptions: (fieldName: string) => void;
}

// Условия триггера «Ключевые слова во входящем сообщении» робота «Установка тега»
export const IncomingMessageTriggerFields: FC<
  IncomingMessageTriggerFieldsProps
> = ({
  form,
  socialIntegrationTypeValue,
  filteredIntegrations,
  handleChannelOptions,
}) => (
  <>
    <KeywordGroupsField
      emptyHint="Если ни одной строки нет, робот срабатывает на любое входящее сообщение."
      emptyWarning="Ключевые слова не добавлены. Робот будет устанавливать теги при каждом входящем сообщении клиента в этом этапе воронки."
      limits={INCOMING_MESSAGE_KEYWORD_GROUPS_LIMITS}
    />

    <SocialChannelFields
      form={form}
      socialIntegrationTypeValue={socialIntegrationTypeValue}
      filteredIntegrations={filteredIntegrations}
      handleChannelOptions={handleChannelOptions}
      required={false}
      defaultChannelLabel="Любой канал"
    />
  </>
);
